import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { ObjectComponentCategory } from '../../model/object-component-category';
import { catchError, map, Observable } from 'rxjs';
import { AutoCompleteSelectionItem } from '../../../core/component/autocomplete-remote/autocomplete-selection-item';

@Injectable()
export class ObjectComponentCategoryService extends DataService<ObjectComponentCategory> {
  constructor(
    client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    private readonly _messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(client, config, _messageService, ObjectComponentCategory, progressBar, 'component-category');
  }

  getSelectionItem(id: string): Observable<AutoCompleteSelectionItem> {
    return this.client.get<any>(`${this.endpoint}/selectionItem/${id}`).pipe(
      map(item => new AutoCompleteSelectionItem(item.name, item.id, item, item.shortName)),
      catchError(e => {
        this._messageService.showError(e);
        return [];
      })
    );
  }

  getSelection(filter: string, options?: any, page?: number): Observable<AutoCompleteSelectionItem[]> {
    let queryArgs = {
      filter: filter,
      maxItems: 20,
    };
    if (options) queryArgs['options'] = options;
    if (page && page > 0) queryArgs['page'] = page;

    return this.client.post<any[]>(`${this.endpoint}/selection`, queryArgs).pipe(
      map(data => data.map(item => new AutoCompleteSelectionItem(item.name, item.id, item, item.shortName))),
      catchError(e => {
        this._messageService.showError(e);
        return [];
      })
    );
  }
}
